import * as angular from 'angular';
import reviewsRouter from './reviews.router';
import ReviewService from './review.service';

/** @constant {angular.module} */
const reviewsModule = angular
  .module('ec.opsCenter.reviews', [])
  .config(reviewsRouter)
  .service('ReviewService', ReviewService).name;

export default reviewsModule;



// WEBPACK FOOTER //
// ./src/app/reviews/reviews.module.ts